// extracted by mini-css-extract-plugin
export var image = "styles-module--image--818a8";
export var post = "styles-module--post--2115a";
export var title = "styles-module--title--3323a";
export var wrapper = "styles-module--wrapper--ae257";